import swal from 'sweetalert2';
import tippy from 'tippy.js';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxReloadable } from '../../Lib/AxSystem/AxReloadable';
import { ProductTypeConstant } from "../../Lib/Constants/ProductTypeConstant";
import { ArrayHelper } from "../../Lib/Helper/ArrayHelper";
import { CookieHelper } from "../../Lib/Helper/CookieHelper";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxAlert } from "../../Limestone/AxAlert/AxAlert";
import { AxButton } from "../../Limestone/AxButton/AxButton";
import { ProgressBar, ProgressBarMode } from "../Global/Progressbar";
import { CartEntryQuantity } from './CartEntryQuantity';

// Declare functions
declare function checkShoppingCartPartialViewResult(result: any): void;
declare function block(elementId: string): void;

@ModuleName("ShoppingCart")
export class ShoppingCart implements AxInit, AxReloadable {
    private initData: ShoppingCartInit;
    private instanceInfo: any;
    constructor(
        protected _Progressbar = new ProgressBar(),
        protected _i18nHelper = new I18nHelper(),
        protected _arrayHelper = new ArrayHelper(),
        protected _axButton = new AxButton(),
        protected _requestHelper = new RequestHelper(),
        protected _cookieHelper = new CookieHelper(),
        protected _dateInitData = new BirthDateInitData(),
        protected _cartEntryQuantity = new CartEntryQuantity()
    ) { }

    AxInit(init: ShoppingCartInit): void {
        this.initData = init;

        $('#cart_holder').on('click', '.tv4_side__selection-timing--toggle', (e) => {
            this.toggleTimings(e.currentTarget);
        });

        new AxAlert('.cart__alert');
        let progress: number = init.progressBarMode == ProgressBarMode.Suballotment ? 3 : 2;

        this._Progressbar.Init({
            Mode: init.progressBarMode,
            Progress: progress
        });

        this.printErrors(init.errorList);
        this.registerEventsPersonHolder();

        $('#cart_holder').on('change', '.PayAtPickup', (e) => {
            this.handlePayAtPickupChange(e.currentTarget.checked);
        });

        $(document)
            .on('visibilitychange', () => AxLoad.ReloadModule('ShoppingCartReservationTimer'))
            .on('keydown', 'input[data-license-plate]', (e) => {
                const pattern: RegExp = /^[a-zA-Z0-9äëïöüÄËÏÖÜ]$/g;
                const regExp = new RegExp(pattern);
                if (e.ctrlKey || e.altKey || typeof e.key !== 'string' || e.key.length !== 1) {
                    return;
                }
                if (!regExp.test(e.key) && e.key !== 'Backspace') {
                    e.preventDefault();
                }
            })
            .on('keyup', 'input[data-license-plate]', (e) => {
                $(e.target).val(($(e.target).val()).toUpperCase());
            });

        this.CheckIfWaiverIsRequired();
        $('#cart_holder').on('click', '[data-shoppingcart="proceed"]', (e) => {
            //---------- terrible outdated code, don't extend, refactor -----------------
            let openpassMissing = false;
            $('.cart-pos').each(function (index, elem) {
                let id = $(elem).attr('id').replace('position_', '');

                let hiddenInputProductType = $('input#productType_' + id);
                if ($(hiddenInputProductType).val() == '' + ProductTypeConstant.OPENPASS && $('.openPass-input-' + id).val() == '') {
                    openpassMissing = true;
                }
            });

            if (openpassMissing) {
                swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    html: this._i18nHelper.GetTranslation(Translations.WtpPleaseInsert),
                    icon: 'error',
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                });
                return;
            }

            if ($('.legitimationDisclaimer:checkbox:not(:checked)').length != 0) {
                e.preventDefault();
                swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    html: this._i18nHelper.GetTranslation(Translations.LegitimationCheckError),
                    icon: 'error',
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                });
                return;
            }


            let validationError = false;
            $('.cart__addArticleSelect').each((i, e) => {
                if ($(e).val() == 0 || $(e).val() == "") {
                    swal.fire({
                        title: this._i18nHelper.GetTranslation(Translations.Error),
                        html: this._i18nHelper.GetTranslation(Translations.ProductSelectionRequired),
                        icon: 'error',
                        customClass: {
                            closeButton: 'btn btn-secondary',
                            confirmButton: 'btn btn-primary',
                        },
                        confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                    });
                    $(e).addClass('invalid');
                    validationError = true;
                }
            });

            $('input[data-license-plate]').each((i, e) => {
                $(e).val($(e).val().toString().replace(/[^A-Z0-9ÄËÏÖÜ]/g, ''));
            });

            //Look for visible linked-article-waiver-item that have not checked checkboxes.
            const hasUncheckedWaiversForAdditionalArticles = $('.linked-article-waiver-item:not(.d-none)').find('.linkedArticleWaiver_checkBox:checkbox:not(:checked)').length != 0;
            if (hasUncheckedWaiversForAdditionalArticles) {
                e.preventDefault();
                swal.fire({
                    title: this._i18nHelper.GetTranslation(Translations.Error),
                    html: this._i18nHelper.GetTranslation(Translations.LinkedArticleWaiverCheckError),
                    icon: 'error',
                    customClass: {
                        closeButton: 'btn btn-secondary',
                        confirmButton: 'btn btn-primary',
                    },
                    confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
                });
                validationError = true;
            }

            if (validationError) {
                return;
            }
            //-----------------------------------------------------------------
            $('#checkout_form').trigger('submit');
        });

        this._cartEntryQuantity.initQuantityCounters(
            this.deleteGropuedItems,
            this.createGropuedItems,
            this.initData.maxItems
        );
    }

    AxReload(init: any) {
        this._cartEntryQuantity.initQuantityCounters(
            this.deleteGropuedItems,
            this.createGropuedItems,
            this.initData.maxItems
        );
    }

    initPersonalisation() {
        $('.positionPersonalisation_birthday').each((i, e) => {
            const cartEntryId = $(e).attr('data-for-entry');
            const datePatternId = $(`#datePatternId_${cartEntryId}`).val();
            const dateInitData = {
                birthdayPattern: datePatternId.toString(),
                outputTarget: `input[type="hidden"]#DateOfBirthCi_${cartEntryId}`,
                parentId: `#needPersonId_${cartEntryId}`,
                setBirthDate: $(`#DateOfBirthCi_${cartEntryId}`).val(),
            };
            AxLoad.LoadModule('AxBirthDateInputTriple', dateInitData);
        });
    }

    registerEventsPersonHolder() {
        $('#cart_holder').on('blur', '.person-form input[type=text], .person-form input[type=hidden], .person-form .ax-dropdown__trigger', (e) => {
            const cartEntryIDToUpdatePerson = $(e.currentTarget).attr('data-for-entry');

            $('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__firstname').removeClass('invalid');
            $('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__lastname').removeClass('invalid');
            $('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__dateofbirth').removeClass('invalid');

            const firstName = ($('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__firstname').val() as string).trim();
            const lastName = ($('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__lastname').val() as string).trim();

            const dateOfBirth = ($('#personalisation_' + cartEntryIDToUpdatePerson + ' .ce-person__dateofbirth').val() as string).trim();

            this.updateEntryPerson(firstName, lastName, dateOfBirth, cartEntryIDToUpdatePerson);
        });
    }

    updateEntryPerson(firstName: string, lastName: string, dateOfBirth: string, cartEntryId: string) {
        if (firstName != '' && lastName != '' && dateOfBirth != '') {
            let data = {
                cartEntryID: cartEntryId,
                Firstname: firstName,
                Lastname: lastName,
                DateOfBirth: dateOfBirth
            };
            AxessViewer.loadPartialView('/ShoppingCart/UpdateEntryPerson', data, resp => { }, {
                silent: true
            });

        } else {
            if (firstName == '') {
                $('#personalisation_' + cartEntryId + ' .ce-person__firstname').addClass('invalid');
            }
            if (lastName == '') {
                $('#personalisation_' + cartEntryId + ' .ce-person__lastname').addClass('invalid');
            }
            if (dateOfBirth == '') {
                $('#personalisation_' + cartEntryId + ' .ce-person__dateofbirth').addClass('invalid');
            }
        }
    }

    StateInit(state: ShoppingCartState): void {
        this.displayPayAtPickupPrices(state.checkboxState);
    }

    displayPayAtPickupPrices(isChecked) {
        if (isChecked) {
            $('.PayAtPickupPrices').show();
            $('.control-alert').show();
        } else {
            $('.PayAtPickupPrices').hide();
            $('.control-alert').hide();
        }
    }

    handlePayAtPickupChange(isChecked) {
        this._cookieHelper.setCookie('payAtPickup', isChecked, 1);
        this.displayPayAtPickupPrices(isChecked);
    }

    toggleTimings(target: HTMLElement) {
        let $e = $(target);
        $e.next().slideToggle('fast');
        $e.find('i').toggleClass('las la-angle-down').toggleClass('las la-angle-up');
    }

    printErrors(errorList: ResponseModel[]) {
        if (errorList == null || errorList.length === 0) {
            return;
        }

        errorList.forEach((e) => {
            this.addNewMessage(`[data-error-cart-entry-id="${e.id}"]`, e.id, e.errorNr, e.errorMsg);
        });
    }

    CheckIfWaiverIsRequired() {
        if (this.initData.WaiverIsEnabled) {
            this.handleWaiverEnabled();
        } else {
            this.showProceedButton();
        }
    }

    handleWaiverEnabled() {
        if (this.initData.OneRISKProcessRequired) {
            this.handleOneRiskProcessRequired();
        } else {
            this.handleOneRiskNotRequired();
        }
    }

    handleOneRiskProcessRequired() {
        if ($('.waiver__tripple').length > 0) {
            this.checkAllOneRiskProcessesCompleted();
        } else {
            this.showProceedButton();
        }
    }

    handleOneRiskNotRequired() {
        if ($('.waiver__tripple').length > 0) {
            swal.fire({
                title: this._i18nHelper.GetTranslation(Translations.Warning),
                html: this._i18nHelper.GetTranslation(Translations.OneRISKNecessityMessage),
                icon: 'warning',
                customClass: {
                    closeButton: 'btn btn-secondary',
                    confirmButton: 'btn btn-primary',
                },
                confirmButtonText: this._i18nHelper.GetTranslation(Translations.Ok),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.showProceedButton();
                }
            });
        } else {
            this.showProceedButton();
        }
    }

    checkAllOneRiskProcessesCompleted() {
        let allTrue = true;

        $('.waiver__tripple').each((i, e) => {
            let oneRiskprocessCompleted = $(e).attr('one-risk-completed');

            if (oneRiskprocessCompleted !== 'true') {
                allTrue = false;
                return false;
            }
        });

        if (allTrue) {
            this.showProceedButton();
        } else {
            this.hideProceedButtonWithTooltip();
        }
    }

    hideProceedButtonWithTooltip() {
        $('[data-shoppingcart="proceed"]').replaceWith(
            $('<span>')
                .addClass('ax-btn ax-btn ax-btn-secondary flex-1 flex-lg-grow-0')
                .attr('data-shoppingcart', 'waiverIsRequired')
                .html(this._i18nHelper.GetTranslation(Translations.OneRISKProcessIsRequiredBeforeProceed) + '<i class="la la-exclamation-circle"></i>')
        );
        this.instanceInfo = tippy(document.querySelector('.waiver__inactive'), {
            content: this._i18nHelper.GetTranslation(Translations.OneRISKProcessIsRequiredBeforeProceed),
            placement: 'bottom',
            interactive: true,
            trigger: 'manual',
            theme: 'material',
        });
        this.instanceInfo.show();
        $('.waiver__inactive').addClass('waiver-border ax-border-radius');
        this._axButton.StopLoading($('.proceedToCheckoutBtn')[0]);
    }

    showProceedButton() {
        $('[data-shoppingcart="proceed"]').replaceWith(
            $('<button>')
                .addClass('ax-btn ax-btn-primary flex-1 flex-lg-grow-0')
                .attr('data-shoppingcart', 'proceed')
                .html(this._i18nHelper.GetTranslation(Translations.ProceedToCheckout))
        );
    }

    // Add (<div data-cart-entry-id="cartEntryId" data-error-code="code"> + <span> message </span> </div>) to the containerSelector.
    addNewMessage(containerSelector, cartEntryId, code, message) {
        const div$ = $('<div>', { class: 'validation-warning col-lg-12 pl-4' }).attr('data-cart-entry-id', `${cartEntryId}`).attr('data-error-code', `${code}`);
        const span$ = $('<span>', { class: 'error-holder ax-ml-1' }).html(message);

        $(`${containerSelector}`).append(div$.append(span$));
        $(`${containerSelector}`).removeClass('d-none');
    };

    private deleteGropuedItems(cartEntryId: string, itemsToDelete: string[]) {
        block('#cart_holder');
        const relatedTickets = itemsToDelete.reduce((acc, x) => acc += Boolean(x) ? '&relatedTickets=' + x : '', '');
        const data = $("#checkout_form").serialize() + "&targetPositionId=" + cartEntryId + relatedTickets;
        AxessViewer.loadPartialView('/ShoppingCart/RemoveFromCart', data, checkShoppingCartPartialViewResult);
    }

    private createGropuedItems(cartEntryId: string, itemsToAdd: number) {
        block('#cart_holder');
        const data = $("#checkout_form").serialize() + "&cartEntryId=" + cartEntryId + "&numberOfItemsToAdd=" + itemsToAdd;
        AxessViewer.loadPartialView('/ShoppingCart/AddGroupedTicketToCart', data, checkShoppingCartPartialViewResult);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const shoppingCart = new ShoppingCart();
    const cookieHelper = new CookieHelper();

    let payAtPickupState = true;
    const payAtPickupCookie = cookieHelper.getCookie('payAtPickup');

    if (payAtPickupCookie !== null) {
        payAtPickupState = payAtPickupCookie === 'true';
    } else {
        cookieHelper.setCookie('payAtPickup', 'true', 1);
    }

    $('.PayAtPickup').prop('checked', payAtPickupState);
    shoppingCart.displayPayAtPickupPrices(payAtPickupState);
});

class ShoppingCartInit {
    processIndicatorActive?: boolean;
    progressBarMode?: ProgressBarMode;
    customerSignedIn?: boolean;
    OneRISKProcessRequired?: boolean;
    WaiverIsEnabled?: boolean;
    errorList: ResponseModel[];
    maxItems: number;
}

class ShoppingCartState {
    checkboxState?: boolean;
}

class BirthDateInitData {
    birthdayPattern: string;
    parentId: string;
    outputTarget: string;
    setDay: string;
    setMonth: string;
    setYear: string;
    setBirthDate: string;
}

class ResponseModel {
    errorTitle: string;
    success: boolean;
    errorNr: number;
    errorMsg: string;
    id: number;
}